'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import {
  ChartBarIcon,
  FolderOpenIcon,
  DocumentTextIcon,
  Square3Stack3DIcon,
  TableCellsIcon,
  ArrowDownTrayIcon,
} from '@heroicons/react/24/outline';

const MOBILE_NAV = [
  { href: '/dashboard', label: 'Skydelis', icon: ChartBarIcon },
  { href: '/projects', label: 'Projektai', icon: FolderOpenIcon },
  { href: '/dokumentai', label: 'Dokumentai', icon: DocumentTextIcon },
  { href: '/fasadai', label: 'Fasadai', icon: Square3Stack3DIcon },
  { href: '/samata', label: 'Sąmata', icon: TableCellsIcon },
  { href: '/eksportas', label: 'Eksportas', icon: ArrowDownTrayIcon },
];

export default function MobileNav() {
  const pathname = usePathname();

  return (
    <nav data-component-id="src/components/MobileNav.tsx:28:4" data-component-path="src/components/MobileNav.tsx" data-component-line="28" data-component-end-line="42" data-component-file="MobileNav.tsx" data-component-name="nav" data-component-content="%7B%22elementName%22%3A%22nav%22%2C%22className%22%3A%22mobile-nav%22%7D" className="mobile-nav" aria-label="Mobilusis meniu">
      {MOBILE_NAV.map(({ href, label, icon: NavIcon }) => {
        const isActive = pathname === href || (href !== '/dashboard' && pathname?.startsWith(href));
        return (
          <Link data-component-id="src/components/MobileNav.tsx:32:10" data-component-path="src/components/MobileNav.tsx" data-component-line="32" data-component-end-line="39" data-component-file="MobileNav.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%5Bvar%3Ahref%5D%22%7D"
            key={href}
            href={href}
            className={`mobile-nav__item ${isActive ? 'mobile-nav__item--active' : ''}`}
          >
            <NavIcon data-component-id="src/components/MobileNav.tsx:37:12" data-component-path="src/components/MobileNav.tsx" data-component-line="37" data-component-end-line="37" data-component-file="MobileNav.tsx" data-component-name="NavIcon" data-component-content="%7B%22elementName%22%3A%22NavIcon%22%7D" />
            <span data-component-id="src/components/MobileNav.tsx:38:12" data-component-path="src/components/MobileNav.tsx" data-component-line="38" data-component-end-line="38" data-component-file="MobileNav.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D">{label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
